import {
  AccessStatusEnum,
  RequestStatusButton,
  RequestsDetailsModal,
} from '@agilelab/plugin-wb-platform';
import { anyCaseToCapitalCase } from '@agilelab/plugin-wb-platform-common';
import {
  Badge,
  Box,
  TableCell,
  TableRow,
  Theme,
  Typography,
  createStyles,
  makeStyles,
  withStyles,
} from '@material-ui/core';
import { WbTooltip } from '@agilelab/plugin-wb-platform';
import CancelIcon from '@material-ui/icons/Cancel';
import GroupIcon from '@material-ui/icons/Group';
import PersonIcon from '@material-ui/icons/Person';
import clsx from 'clsx';
import { MouseEventHandler, useState } from 'react';
import { ACLByDP } from './DataAccessTab';

const useStyles = makeStyles(theme => ({
  tableRow: {
    position: 'relative',
    backgroundColor: theme.palette.background.default,
    '&:hover': {
      backgroundColor: theme.palette.bkg.primary,
    },
  },
  border: {
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
  },
}));

const StyledBadge = withStyles((theme: Theme) =>
  createStyles({
    badge: {
      right: -3,
      top: 22,
      border: `2px solid ${theme.palette.background.paper}`,
      padding: '0 4px',
      backgroundColor: theme.palette.success.main,
      zIndex: 'auto',
    },
  }),
)(Badge);

export const Row = (props: { row: ACLByDP }) => {
  const { row } = props;
  const classes = useStyles();
  const [openDetails, setOpenDetails] = useState<boolean>(false);

  const handleClick:
    | (MouseEventHandler<HTMLAnchorElement> &
        MouseEventHandler<HTMLSpanElement>)
    | undefined = e => {
    e.preventDefault();
    e.stopPropagation();
    setOpenDetails(true);
  };
  const handleClose = () => {
    setOpenDetails(false);
  };

  return (
    <>
      <RequestsDetailsModal
        open={openDetails}
        onClose={handleClose}
        requests={row.requests!}
        displayName={row.displayName}
      />
      <TableRow className={clsx(classes.tableRow, classes.border)}>
        <TableCell size="medium" align="left">
          <Typography style={{ fontWeight: 'bold' }}>
            {row.displayName}
          </Typography>
          {row.parent && (
            <Typography variant="caption">{row.parent.displayName}</Typography>
          )}
        </TableCell>
        <TableCell align="left">
          <Typography>{anyCaseToCapitalCase(row.type, true)}</Typography>
        </TableCell>
        <TableCell align="left">
          <Box display="flex" alignItems="center" style={{ gap: 16 }}>
            {(row?.refs?.user || !!row?.refs?.groups?.length) && (
              <Box display="flex">
                {row?.refs?.user && <PersonIcon />}
                {row?.refs?.user && !!row?.refs?.groups?.length && (
                  <Typography>+</Typography>
                )}
                {!!row?.refs?.groups?.length && (
                  <WbTooltip
                    title={
                      <div style={{ whiteSpace: 'pre-line' }}>
                        {row?.refs?.groups?.join('\n')}
                      </div>
                    }
                  >
                    <StyledBadge
                      badgeContent={row.refs.groups?.length}
                      color="secondary"
                    >
                      <GroupIcon />
                    </StyledBadge>
                  </WbTooltip>
                )}
              </Box>
            )}
            {row.access === AccessStatusEnum.Disabled && (
              <CancelIcon color="disabled" />
            )}
            <Typography>{row.access}</Typography>
          </Box>
        </TableCell>

        <TableCell>
          {row.status && (
            <RequestStatusButton
              status={row.status}
              handleClick={handleClick}
              label={` ${row.requests?.length} Requests`}
            />
          )}
        </TableCell>
      </TableRow>
    </>
  );
};
